import { Map } from 'immutable';

//Action Types
export const Types = {
  SET_CURRENT_CONFIGURACAO_INFORMACAO: 'SET_CURRENT_CONFIGURACAO_INFORMACAO',
};

//Action Creators
export const setInformacao = (informacao) => ({ type: Types.SET_CURRENT_CONFIGURACAO_INFORMACAO, informacao });

// Reducer
const initialState = Map({
  informacao: {},
});

const handleSetInformacao = (state, action) => {
  const { informacao } = action;
  return state.set('informacao', informacao);
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.SET_CURRENT_CONFIGURACAO_INFORMACAO:
      return handleSetInformacao(state, action);

    default:
      return state;
  }
}
